"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var Meta = function Meta(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  return (0, _preact.h)(_phrase.default, {
    p: "search.result.metadata.aria.label",
    m: "Forum",
    renderAsText: true
  }, function (phrase) {
    return (0, _preact.h)("div", {
      className: "search-result-meta",
      role: "list",
      "aria-label": phrase,
      tabIndex: 0
    }, items.filter(function (item) {
      return !!item.text;
    }).map(function (item, index) {
      var _item$href;

      return (0, _preact.h)("div", {
        className: "search-result-meta--item",
        key: index,
        role: "listitem"
      }, index !== 0 && (0, _preact.h)("span", {
        className: "search-result-meta--separator",
        "aria-hidden": "true"
      }), (0, _preact.h)("a", {
        className: (0, _classnames.default)('search-result-meta--item', {
          'pill pill--uppercase pill--article': item.type === 'pill'
        }),
        href: (0, _absoluteUrlRuntime.resolveUrl)((_item$href = item.href) !== null && _item$href !== void 0 ? _item$href : '#'),
        style: item.type === 'pill' ? item.style : undefined
      }, item.text));
    }));
  });
};

var _default = Meta;
exports.default = _default;